import React from 'react';

const GalleryPage = React.lazy(() => import('pages/VideoGallery/GalleryPage'));
const GalleryAddPage = React.lazy(() => import('pages/VideoGallery/GalleryAddPage'));

const galleryRoute = [
  {
    path: '/video-gallery',
    exact: true,
    name: 'Danh sách video',
    function: 'CMS_GALLERY_VIEW',
    component: GalleryPage,
  },
  {
    path: '/video-gallery/add',
    exact: true,
    name: 'Thêm mới video',
    function: 'CMS_GALLERY_ADD',
    component: GalleryAddPage,
  },
  {
    path: '/video-gallery/edit/:video_id',
    exact: true,
    name: 'Chỉnh sửa video',
    function: 'CMS_GALLERY_EDIT',
    component: GalleryAddPage,
  },
  {
    path: '/video-gallery/detail/:video_id',
    exact: true,
    name: 'Chi tiết video',
    function: 'CMS_GALLERY_VIEW',
    component: GalleryAddPage,
  },
];

export default galleryRoute;
